<template>
  <div>
    <v-layout row v-if="color === 'secondary'">
      <v-flex xs6 class="bl1"/>
      <v-flex xs6 class="br"/>
    </v-layout>
    <v-layout row v-if="color === 'primary'">
      <v-flex xs6 class="bl2"/>
      <v-flex xs6 class="br"/>
    </v-layout>
  </div>
</template>

<script>

export default {
  name: 'BalanceBorder',
  props: {
    color: String
  }
}
</script>

<style>
.bl1, .bl2, .br {
  height: 5px;
  margin: 16px 0;
}
.xsOnly .bl1, .xsOnly .bl2, .xsOnly .br {
  height: 3px;
  margin: 12px 0;
}
.br {
  background-color: gainsboro;
}
.bl1 {
  background-color: #CC5803;
}
.bl2 {
  background-color: #A8201A;
}
</style>
